// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .no-size-chart-group-row {
  padding: 24px 34px;
}
.presize-root .no-size-chart-group-row .no-size-chart-group-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
}
.presize-root .no-size-chart-group-row a {
  text-decoration: underline;
}
/*# sourceMappingURL=NoSizeChartGroupRow.css.map */`, "",{"version":3,"sources":["webpack://./NoSizeChartGroupRow.less","webpack://./src/pages/SizingGroupList/NoSizeChartGroupRow.less"],"names":[],"mappings":"AAAA;EAEE,kBAAA;ACAF;ADFA;EAKI,eAAA;EACA,iBAAA;EACA,mBAAA;ACAJ;ADPA;EAWI,0BAAA;ACDJ;AACA,kDAAkD","sourcesContent":[".presize-root { \n .no-size-chart-group-row {\n  padding: 24px 34px;\n\n  .no-size-chart-group-name {\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 12px;\n  }\n\n  a {\n    text-decoration: underline;\n  }\n}\n \n}",".presize-root .no-size-chart-group-row {\n  padding: 24px 34px;\n}\n.presize-root .no-size-chart-group-row .no-size-chart-group-name {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 12px;\n}\n.presize-root .no-size-chart-group-row a {\n  text-decoration: underline;\n}\n/*# sourceMappingURL=NoSizeChartGroupRow.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
